import React, { useEffect, useContext, useState, useMemo } from 'react';
import Badge from '../../../components/base/Badge';
import RevealDropdown, {
  RevealDropdownTrigger
} from '../../../components/base/RevealDropdown';
import { useMainLayoutContext } from '../../../providers/MainLayoutProvider';
import { Col, Dropdown, Row, Button } from 'react-bootstrap';
import { UilStopwatch } from '@iconscout/react-unicons';
import TaskCompletedGant from '../../../components/project-management/project-details/TaskCompletedGant';
import WorkLoads from '../../../components/project-management/project-details/WorkLoads';
import ConsumptionDetails from '../../production-management/ConsumptionDetails';
import TeamMembers from '../../../components/project-management/project-details/TeamMembers';
import ProjectDetailsSummary from '../../../components/project-management/project-details/ProjectDetailsSummary';
import ActivityTimeline from '../../../components/timelines/ActivityTimeline';
import { activityTimelineData } from '../../../data/project-management/activityTimelineData';
import MachineSpeedGauge from '../../../components/charts/machines-charts/MachineSpeedGauge';
import MachineTempZonesChart from '../../../components/charts/machines-charts/MachineTempZonesChart';
import MachineDiameterChart from '../../../components/charts/machines-charts/MachineDiameterChart';
import MachinePowerPercentageGauge from '../../../components/charts/machines-charts/MachinePowerPercentageGauge';
import MachineTemperatureGauge from '../../../components/charts/machines-charts/MachineTemperatureGauge';
import MachineAmpsGraph from '../../../components/charts/machines-charts/MachineAmpsGraph';
import MachineRpmChart from '../../../components/charts/machines-charts/MachineRpmChart';
import MachinePercentageLineChart from '../../../components/charts/machines-charts/MachinePercentageLineChart';
import { MachineDataContext } from '../../../providers/MachineDataContext';
import MachineTotalMetersChart from '../../../components/charts/machines-charts/MachineTotalMetersChart';
import { useAppContext } from '../../../providers/AppProvider';
import { FallingLines } from 'react-loader-spinner';
import getShiftStartEndTime, {
  updateTimeRange
} from '../../../components/charts/utils/chartUtils';
import MachineMaxActCounterChart from '../../../components/charts/machines-charts/MachineMaxActCounterChart';
import MachineDoubleLineChart from '../../../components/charts/machines-charts/MachineDoubleLineChart';
import MachimeTime from '../../../components/cards/MachimeTime.js';
import MachineTotalProduction from '../../../components/charts/machines-charts/MachineTotalProduction.js';
import ActiveBreakTimeBarChart from '../../../components/charts/machines-charts/ActiveBreakTimeBarChart.js';
import DiameterSetTotalProduced from '../../../components/charts/machines-charts/DiameterSetTotalProduced.js';
import TotalPvcConsumed from '../../../components/cards/TotalPvcConsumed.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleRight,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import DisplayShift from '../../../components/base/DisplayShift.js';
import LazyLoadChart from '../../../components/common/LazyLoadChart.js';
import SparkTesterChart from '../../../components/charts/machines-charts/SparkTesterChart.js';
import SparkTesterStatus from '../../../components/base/SparkTesterStatus.js';
import SparkTesterPieces from '../../../components/cards/SparkTesterPieces.js';
import MachineModeStatus from '../../../components/base/MachineModeStatus.js';
import WasteDisplay from '../../../components/cards/WasteDisplay.js';
import TotalColorYield from '../../../components/cards/TotalColorYield.js';

import { WebSocketContext } from '../../../providers/WebSocketProvider.js';
import '../../../components/machines/trackingHeader.css';

const L75Traking = () => {
  const { setContentClass } = useMainLayoutContext();

  const { machineSingle, subscribeToChannel, unsubscribeToChannel } =
    useContext(WebSocketContext);

  // Memoize reversed reports with a fallback for undefined reports
  const reversedReports = useMemo(
    () =>
      machineSingle?.state?.reports
        ? machineSingle.state.reports.slice().reverse()
        : [],
    [machineSingle?.state?.reports]
  );

  useEffect(() => {
    console.log('Subscribing to machine-all channel');
    subscribeToChannel('machine-single', 'l75');

    return () => {
      console.log('UNSUBSCRIBING from machine-all channel');
      unsubscribeToChannel();
    };
  }, []);

  const {
    config: { theme },
    getThemeColor
  } = useAppContext();

  // const { startTime, endTime } = getShiftStartEndTime();

  const initialShiftTimes = getShiftStartEndTime();

  const currentDay = dayjs();

  // State for startTime and endTime
  const [timeRange, setTimeRange] = useState({
    startTime: initialShiftTimes.startTime,
    endTime: initialShiftTimes.endTime
  });

  const { startTime, endTime } = timeRange;

  console.log('Current Time Range:', { startTime, endTime });

  const isWithinShift = currentDay.isBetween(
    dayjs(timeRange.startTime),
    dayjs(timeRange.endTime)
  );

  const handleUpdate = direction => {
    const { startTime, endTime } = updateTimeRange(timeRange, direction);
    setTimeRange(prevRange => ({
      startTime,
      endTime
    }));
  };

  // Function to update the time range by a specific amount

  useEffect(() => {
    setContentClass('px-0 pt-navbar');

    return () => {
      setContentClass('');
    };
  }, []);
  if (!machineSingle || machineSingle.machine !== 'l75') {
    return (
      <div style={styles.spinnerContainer}>
        <FallingLines
          color={theme === 'dark' ? 'white' : '#3874ff'}
          width="100"
          visible={true}
          ariaLabel="falling-circles-loading"
          // wrapperStyle ={styles.spinnerContainer}
        />
      </div>
    );
  }

  return (
    <Row className="g-0 border-bottom border-300">
      <Col xs={12} xxl={isWithinShift ? 8 : 12} className="px-0 bg-soft">
        <div className="px-4 px-lg-6 pt-6 pb-9">
          <div className="mb-5">
            <div className="tracking-header">
              {/* Machine Overview */}
              <h2 className="text-black fw-bolder mb-2 tracking-header__title">
                Machine L75 overview
              </h2>

              {/* Timeline: Center-aligned */}
              <div
                className="d-flex align-items-center mx-auto"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px'
                }}
              >
                <button
                  className="btn btn-link p-0"
                  aria-label="Previous date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    handleUpdate(-1);
                  }} // Decrease by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronLeft}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center'
                  }}
                >
                  {dayjs(startTime).format('MMMM D, YYYY, h:mm A')}
                </span>
                <button
                  className="btn btn-link p-0"
                  aria-label="Next date"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    border: 'none',
                    backgroundColor: 'transparent',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition:
                      'transform 0.3s ease, background-color 0.3s ease'
                  }}
                  onMouseEnter={e => {
                    e.target.style.backgroundColor = '#004DFF';
                    theme === 'dark'
                      ? (e.target.style.color = 'white')
                      : (e.target.style.color = 'black');
                  }}
                  onMouseLeave={e =>
                    (e.target.style.backgroundColor = 'transparent')
                  }
                  onClick={() => {
                    handleUpdate(+1);
                  }} // Increase by 12 hours
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{
                      fontSize: '16px',
                      transition: 'transform 0.3s ease'
                    }}
                  />
                </button>
              </div>

              {/* Right half — sizing lives in trackingHeader.css */}
              <div className="tracking-header__aside">
                <DisplayShift
                  machineName={'l75'}
                  bucket={'machine_data'}
                  startTime={startTime}
                  endTime={endTime}
                />

                <RevealDropdownTrigger>
                  <RevealDropdown>
                    <Dropdown.Item>Edit</Dropdown.Item>
                    <Dropdown.Item className="text-danger">Delete</Dropdown.Item>
                    <Dropdown.Item>Download</Dropdown.Item>
                    <Dropdown.Item>Report abuse</Dropdown.Item>
                  </RevealDropdown>
                </RevealDropdownTrigger>
              </div>
            </div>

            {/* Badges Section */}
            <div className="d-flex justify-content-between align-items-center mt-3">
              <Badge
                variant="phoenix"
                bg={machineSingle.state.status.type}
                iconPosition="end"
                icon={<UilStopwatch size={12} className="ms-1" />}
              >
                {machineSingle.state.status.label}
              </Badge>

              <MachineModeStatus
                bucket="machine_data"
                machineName="l75"
                startTime={startTime}
                endTime={endTime}
              />
            </div>
          </div>
          <Row className="gx-0 gx-sm-5 gy-8 mb-8">
            <Col xs={12} sm={12} lg={6} xl={6} xxl={6}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalProduction
                  bucket={'machine_data'}
                  machineName={'l75'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Total Meter Produced On Time'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={6} xl={6} xxl={6}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <DiameterSetTotalProduced
                  bucket={'machine_data'}
                  machineName={'l75'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Length produced with diameter check'}
                  field={'DiameterSetValue'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={8} xl={8} xxl={8} className="pe-xl-0">
              <LazyLoadChart>
                <SparkTesterChart
                  bucket={'machine_data'}
                  machineName={'l75'}
                  sparkKv={'SparkActualKv'}
                  sparkPieces={'SparkPieces'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col
              xs={12}
              sm={4}
              xl={4}
              xxl={4}
              className="d-flex align-items-center justify-content-center"
            >
              <LazyLoadChart>
                <SparkTesterPieces
                  bucket={'machine_data'}
                  machineName={'l75'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  time={'totalActiveTime'}
                  bucket={'machine_data'}
                  machineName={'l75'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Active Machine Minutes'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <MachimeTime
                  time={'totalBreakTime'}
                  bucket={'machine_data'}
                  machineName={'l75'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Break Machine Minutes'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={12} xxl={12} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <ActiveBreakTimeBarChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_30minute'}
                  machineName={'l75'}
                  fields={'ACTIVE_TIME,BREAK_TIME'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Active Break Time'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12} xxl={12}>
              {/* TOTAL METER PRODUCED */}
              <LazyLoadChart>
                <MachineTotalMetersChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  machineName={'l75'}
                  fields={'total_produced'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={4} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Line Speed'}
                  speed={machineSingle.state.currentPlcState.LineSpeed.toFixed(
                    2
                  )}
                  startTime={startTime}
                  endTime={endTime}
                />
              )}
            </Col>
            <Col xs={12} sm={8} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  title={'Line Speed'}
                  machineName={'l75'}
                  fields={'LineSpeed'}
                  startTime={startTime}
                  endTime={endTime}
                  machineStatus={'running'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={4} xl={6} xxl={6} className="pe-xl-0">
              <MachinePercentageLineChart
                dynamicBucket={'true'}
                bucket={'machine_data_minute'}
                title={'L75 RPM'}
                machineName={'l75'}
                fields={'E75_ScrewRpmValue'}
                startTime={startTime}
                endTime={endTime}
              />
            </Col>
            <Col xs={12} sm={8} xl={6} xxl={isWithinShift ? 6 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  dynamicBucket={'true'}
                  bucket={'machine_data_minute'}
                  title={'L45 RPM'}
                  machineName={'l75'}
                  fields={'E45_ScrewRpmValue'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={4} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Master Percentage'}
                  speed={machineSingle.state.currentPlcState.MazterActualValue.toFixed(
                    2
                  )}
                  startTime={startTime}
                  endTime={endTime}
                />
              )}
            </Col>

            <Col xs={12} sm={8} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Master Percentage'}
                  machineName={'l75'}
                  fields={'MazterActualValue'}
                  startTime={startTime}
                  endTime={endTime}
                />{' '}
              </LazyLoadChart>
            </Col>

            <Col xs={12} sm={4} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'E75 Percentage'}
                  speed={machineSingle.state.currentPlcState.E75_PercentReferenceValue.toFixed(
                    2
                  )}
                  startTime={startTime}
                  endTime={endTime}
                />
              )}
            </Col>
            <Col xs={12} sm={8} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'E75 Extruder Percentage'}
                  machineName={'l75'}
                  fields={'E75_PercentReferenceValue'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={4} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'E45 Percentage'}
                  speed={machineSingle.state.currentPlcState.E45_PercentReferenceValue.toFixed(
                    2
                  )}
                  startTime={startTime}
                  endTime={endTime}
                />
              )}
            </Col>
            <Col xs={12} sm={8} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'E45 Extruder Percentage'}
                  machineName={'l75'}
                  fields={'E45_PercentReferenceValue'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>

            <Col xs={12} sm={4} xl={3} xxl={4} className="pe-xl-0">
              {isWithinShift && (
                <MachineSpeedGauge
                  name={'Pulling Percentage'}
                  speed={machineSingle.state.currentPlcState.CapstanPercenRef.toFixed(
                    2
                  )}
                  startTime={startTime}
                  endTime={endTime}
                />
              )}
            </Col>
            <Col xs={12} sm={8} xl={9} xxl={isWithinShift ? 8 : 12}>
              <LazyLoadChart>
                <MachinePercentageLineChart
                  bucket={'machine_data_minute'}
                  title={'Pulling Percentage'}
                  machineName={'l75'}
                  fields={'CapstanPercenRef'}
                  startTime={startTime}
                  endTime={endTime}
                />{' '}
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12}>
              <LazyLoadChart>
                <MachineDiameterChart
                  bucket={'machine_data_minute'}
                  machineName={'l75'}
                  fields={'DiameterSetValue,ActualDiameter'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={12} lg={12} xl={12}>
              <MachineMaxActCounterChart
                bucket={'machine_data_minute'}
                machineName={'l75'}
                fields={'METER_ACT'}
                startTime={startTime}
                endTime={endTime}
              />
            </Col>

            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  bucket={'machine_data_minute'}
                  dynamicBucket={'true'}
                  machineName={'l75'}
                  fields={'E75_MotorCurrentValue'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Distibution of electricity E75'}
                />{' '}
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} lg={6} xl={6}>
              <LazyLoadChart>
                <MachineAmpsGraph
                  bucket={'machine_data_minute'}
                  dynamicBucket={'true'}
                  machineName={'l75'}
                  fields={'E45_MotorCurrentValue'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'Distibution of electricity E45'}
                />
              </LazyLoadChart>
            </Col>

            <Col
              xs={12}
              sm={2}
              xl={2}
              xxl={2}
              className="d-flex align-items-center justify-content-center"
            >
              <LazyLoadChart>
                <WasteDisplay
                  bucket="machine_data"
                  startTime={startTime}
                  endTime={endTime}
                  title="Total Waste (kg)"
                />
              </LazyLoadChart>
            </Col>

            <Col xs={12} sm={5} lg={5} xl={5}>
              <LazyLoadChart>
                <MachineDoubleLineChart
                  bucket={'machine_data_minute'}
                  dynamicBucket={'true'}
                  machineName={'l75'}
                  fields={'E75_EXTRUDER_ACTUAL_YIELD_PLC,E75_EXTRUDER_ACTUAL_COLOR_YIELD'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'E75 EXTRUDER YIELD  E75 COLOR YIELD'}
                  machineStatus={'running'}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={5} lg={5} xl={5}>
              <LazyLoadChart>
                <MachineDoubleLineChart
                  bucket={'machine_data_minute'}
                  dynamicBucket={'true'}
                  machineName={'l75'}
                  fields={'E45_EXTRUDER_ACTUAL_YIELD_PLC,E45_EXTRUDER_ACTUAL_COLOR_YIELD'}
                  startTime={startTime}
                  endTime={endTime}
                  title={'E45 EXTRUDER YIELD  E45 COLOR YIELD'}
                  machineStatus={'running'}
                />{' '}
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <TotalPvcConsumed
                  bucket={'machine_data'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} sm={6} xl={6} xxl={6} className="pe-xl-0">
              {/* Number of Coils produced */}
              <LazyLoadChart>
                <TotalColorYield
                  bucket={'machine_data'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            {/* <Col xs={12} sm={6} lg={6} xl={6}>
            <MachineRpmChart />
          </Col> */}
          </Row>
          <Row className="gx-0 gx-sm-5 gy-8 mb-8">
            <Col xs={12} xl={8} xxl={8}>
              <LazyLoadChart>
                <MachineTempZonesChart
                  bucket={'machine_data_minute'}
                  title={'E75 Temp'}
                  machineName={'l75'}
                  fields={'E75_Zone1ActualTempValue,E75_Zone2ActualTempValue,E75_Zone3ActualTempValue,E75_Zone4ActualTempValue,E75_ClampActualTempValue,E75_AdaptorActualTempValue,E75_Head1ActualTempValue,E75_Head2ActualTempValue'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
            <Col xs={12} xl={4} xxl={4}>
              <LazyLoadChart>
                <MachineTempZonesChart
                  bucket={'machine_data_minute'}
                  title={'E45 Temp'}
                  machineName={'l75'}
                  fields={'E45_Zone1ActualTempValue,E45_Zone2ActualTempValue,E45_Zone3ActualTempValue,E45_ClampActualTempValue,E45_AdaptorActualTempValue'}
                  startTime={startTime}
                  endTime={endTime}
                />
              </LazyLoadChart>
            </Col>
          </Row>
        </div>
      </Col>
      {isWithinShift ? (
        <Col xs={12} xxl={4} className="px-0 border-start-xxl border-300">
          <div className="border-bottom border-300">
            <div className="bg-light dark__bg-1100 h-100">
              <div className="p-4 p-lg-6">
                <h3 className="text-1000 mb-4 fw-bold">Recent activity</h3>
                <ActivityTimeline reports={reversedReports} />
              </div>
            </div>
          </div>
        </Col>
      ) : (
        ''
      )}
    </Row>
  );
};

const styles = {
  spinnerContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Add a background with some opacity
    zIndex: 1000 // Ensure the spinner is on top
    // backgroundColor: '#000', // Optional: background color
  },
  arrowButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px' /* Set a fixed width for the button */,
    height: '40px' /* Set a fixed height for the button */,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    borderRadius: '50%'
  }
};

export default L75Traking;
